// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2aS4o","author":"Table_author__1LkQ3","authorImage":"Table_authorImage__1NXY0","unreadRow":"Table_unreadRow__20mAM"};